export default "__VITE_ASSET__da994a41__"